<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { Switch } from '@/components/ui/switch'

const route = useRoute()
const store = useStore()

const projectId = computed(() => route.params.project_id)
const enabled = computed(() => store.getters['discussion/isEnabled'](projectId.value))

const setEnabled = (value) => {
  store.commit('discussion/SET_ENABLED', { projectId: projectId.value, enabled: value })
}
</script>

<template>
  <div class="max-w-2xl space-y-3">
    <div class="flex items-center justify-between gap-4 rounded-lg border bg-card p-4">
      <div>
        <div class="text-sm font-semibold">Project chat</div>
        <p class="mt-1 text-sm text-muted-foreground">
          Team chat with comments pinned on the map.
        </p>
      </div>
      <Switch :model-value="enabled" @update:model-value="setEnabled" />
    </div>
  </div>
</template>
